import { render, staticRenderFns } from "./AudienceMailingAdditionalSettings.vue?vue&type=template&id=8099dbb0&scoped=true"
import script from "./AudienceMailingAdditionalSettings.vue?vue&type=script&lang=ts"
export * from "./AudienceMailingAdditionalSettings.vue?vue&type=script&lang=ts"
import style0 from "./AudienceMailingAdditionalSettings.vue?vue&type=style&index=0&id=8099dbb0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8099dbb0",
  null
  
)

export default component.exports